




















































































import {Vue, Component, Watch} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { AudioBarState, ABAction } from '@/stores/audioBar';
import { Song, Lyric, DelayResult, LrcTime } from '@/interfaces';
import ViewSong from '@/components/AudioBar/List/ViewSong/index.vue';

const emptyLyric: Lyric = {
  tlyric: {
    lyric: '',
    version: '',
  },
  lrc: {
    lyric: '',
    version: '',
  },
};

@Component({
  components: {
    ViewSong,
  },
})
export default class List extends Vue {

  @State public audioBar!: AudioBarState;

  public lyric: Lyric  = emptyLyric;

  public isShowViewSong: boolean = false;

  // 歌词自动滚动动画的控制
  private lyricScroller: (() => void) | null = null;

  // 是否关闭自动滚动
  private isCloseAutoScrollLyric: boolean = false;
  private isCloseAutoScrollLyricTimer: DelayResult | null = null;
  // 是否正在自动滚动
  private isAutoScrollLyric: boolean = false;

  // 获取默认歌词数组
  get LyricArr(): LrcTime[] {
    const {lyric} = this;
    return this.$u.getLyricArr(lyric ? lyric.lrc.lyric : undefined);
  }

  // 获取翻译歌词数组
  get TLyricArr(): LrcTime[] {
    const {lyric} = this;
    return this.$u.getLyricArr(lyric && lyric.tlyric ? lyric.tlyric.lyric : undefined);
  }

  // active 歌词的行
  get LyricIndex(): number {
    const {currentTime} = this.audioBar;
    // time offset second
    const timeOffSet = 1.3;
    for (let index = this.LyricArr.length - 1; index >= 0; index--) {
      const element = this.LyricArr[index];
      if ((currentTime + timeOffSet) * 1000 >= element.millisecond) {
        return index;
      }
    }
    return -1;
  }

  // 获取歌词
  public fetchLyric(song: Song | null) {
    if (song) {
      this.$u.get(`/lyric?id=${song.id}`)
        .then((res) => {
          this.lyric = res.failMark || res.nolyric === true ? emptyLyric : res as any;
        });
    } else {
      this.lyric = emptyLyric;
    }
  }

  // 滚动歌词到指定（？激活）行
  public scrollLyricToActive(line?: number) {
    // TODO 多行优化
    // 不满足滚动的条件
    // 关闭、歌曲未播放、面板未显示
    const {audioBar} = this;
    if (this.isCloseAutoScrollLyric || !audioBar.isPlaying || !audioBar.isShowList) {
      return;
    }
    if (this.lyricScroller) { this.lyricScroller(); }
    const actualLine = line !== undefined ? line : this.LyricIndex;
    const LINE_HEIGHT = 32;
    const elContainer = this.$refs.elLyricsContainer as HTMLDivElement;
    const scrollMax = elContainer.scrollHeight - elContainer.clientHeight;
    let target = (actualLine - 3) * LINE_HEIGHT;
    target = 0 < target ? target : 0;
    target = target <= scrollMax ? target : scrollMax;
    // 执行滚动
    this.isAutoScrollLyric = true;
    this.lyricScroller = this.$u.controlScroll({
      el: elContainer,
      duration: 300,
      y: target,
      endCall: () => {
        this.isAutoScrollLyric = false;
      },
    });
  }

  // 滚动到当前歌曲
  public scrollToPlayingSong() {
    const id = this.$u.getProp(this.audioBar.song, 'id', 0);
    const index = this.audioBar.playList.findIndex((s) => s.id === id);
    const scroller = this.$refs.songListScroller as any;
    if (scroller && index > -1) {
      scroller.scrollToItem(index);
    }
  }

  // 歌词滚动事件处理
  public handleLyricScroll() {
    if (this.isAutoScrollLyric) { return; }
    // 主动滚动时屏蔽自动滚动
    this.isCloseAutoScrollLyric = true;
    if (this.isCloseAutoScrollLyricTimer) {
      this.isCloseAutoScrollLyricTimer.cancel();
    }
    // 2.5s 后恢复自动滚动且滚动到指定行
    this.isCloseAutoScrollLyricTimer = this.$u.delay(() => {
      this.isCloseAutoScrollLyric = false;
      this.scrollLyricToActive();
    }, 2500);
    // cancel
    this.isCloseAutoScrollLyricTimer.promise.catch(() => void 0);
  }

  // 点击列表单曲，切换歌曲并播放
  public handleClickSong(id: number) {
    this.$store.dispatch(ABAction('listSongIdAndPlay'), id);
  }

  // 点击列表单曲删除，若是当前歌曲进行切换
  public handleClickDeleteSong(e: MouseEvent, id: number) {
    e.stopPropagation();
    this.$store.dispatch(ABAction('deleteListSongIdAndPlay'), id);
  }

  // 切换音频可视化面板
  public handleClickSwitchViewSong() {
    this.isShowViewSong = !this.isShowViewSong;
    if (!this.isShowViewSong) {
      // 滚动歌曲
      this.scrollToPlayingSong();
    }
  }

  // 清空播放列表
  public handleClickDeleteAll() {
    this.$store.dispatch(ABAction('setPlayList'), []);
  }

  // 关闭列表面板
  public handleClickCloseListPanel() {
    this.$store.dispatch(ABAction('toggleIsShowList'));
  }

  public beforeMount() {
    // first fetch lyric
    this.fetchLyric(this.audioBar.song);
  }

  // 歌曲切换
  @Watch('audioBar.song')
  public onSongChange(val: Song | null) {
    this.fetchLyric(val);

    // 且列表打开状态
    if (this.audioBar.isShowList) {
      this.scrollToPlayingSong();
    }
  }

  // 歌曲播放行索引变化
  @Watch('LyricIndex')
  public onLyricIndexChange(val: number) {
    this.scrollLyricToActive(val);
  }

  // 面板显示、隐藏状态变化
  @Watch('audioBar.isShowList')
  public onIsShowListChange(val: boolean) {
    if (val) {
      // 显示了，1. 滚动到当前歌曲，2. 滚动到当前歌词
      this.scrollLyricToActive();
      this.scrollToPlayingSong();
    }
  }
}
